import type { SupplierTone } from "@shared-core/domain/supplier-portal-wording";
import { Badge } from "../primitives/badge";
import { cn } from "../primitives/utils";

// One colour per meaning across the portal: pink for something the supplier
// has to do, green for fine, amber for a warning, red for a problem, blue for
// in transit, grey for finished or neutral.
const TONE_CLASS: Record<SupplierTone, string> = {
  todo: "bg-primary/10 text-primary",
  ok: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200",
  warn: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200",
  bad: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200",
  info: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200",
  mute: "bg-muted text-muted-foreground",
};

/** A status, worded by the supplier wording table, with its tone's colour. */
export function StatusPill({
  label,
  tone,
  className,
}: {
  label: string;
  tone: SupplierTone;
  className?: string;
}) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1.5 rounded-full border-transparent px-2.5 font-semibold",
        TONE_CLASS[tone],
        className,
      )}
    >
      <span aria-hidden className="size-1.5 rounded-full bg-current" />
      {label}
    </Badge>
  );
}
